import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'bil-pan-card-modal',
  templateUrl: './pan-card-modal.component.html',
  styleUrls: ['./pan-card-modal.component.sass']
})
export class PanCardModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<PanCardModalComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
